import { render, staticRenderFns } from "./DataTableComponent.vue?vue&type=template&id=2c53b55b&scoped=true&"
import script from "./DataTableComponent.vue?vue&type=script&lang=js&"
export * from "./DataTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./DataTableComponent.vue?vue&type=style&index=0&id=2c53b55b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53b55b",
  null
  
)

export default component.exports